import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ensure4LetterIsoLanguage } from "@ankaadia/ankaadia-shared";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { Consent } from "@ankaadia/graphql";
import {
  DynamicDialogConfig as OldDynamicDialogConfig,
  DynamicDialogRef as OldDynamicDialogRef,
} from "primeng-v17/dynamicdialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { environment } from "../../../../../environments/environment";
import { NewUiCheckboxComponent } from "../../../../shared/form/checkbox/new-ui-checkbox.component";
import { FormElementMapModule } from "../../../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../../../shared/test-id/test-id.directive";
import { TranslateDirective } from "../../../../shared/transloco/translate.directive";
import { NewUiTcConsentViewComponent } from "../tc-consent-view/new-ui-tc-consent-view.component";

@Component({
  selector: "new-ui-tc-consent-dialog",
  templateUrl: "./new-ui-tc-consent-dialog.component.html",
  imports: [
    TranslateDirective,
    NewUiTcConsentViewComponent,
    FormsModule,
    ReactiveFormsModule,
    FormElementMapModule,
    TestIdDirective,
    NewUiButton,
    NewUiCheckboxComponent,
  ],
})
export class NewUiTcConsentDialogComponent implements OnInit {
  consents: Consent[];
  agreedControl = new FormControl(false);
  viewLanguage: string;
  reRender = true;
  lastIndex = 0;

  constructor(
    @Inject(environment.newUI ? DynamicDialogRef : OldDynamicDialogRef)
    private readonly dialogRef: DynamicDialogRef | OldDynamicDialogRef,
    @Inject(environment.newUI ? DynamicDialogConfig : OldDynamicDialogConfig)
    private readonly config: DynamicDialogConfig | OldDynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.consents = this.config.data;
    this.viewLanguage = ensure4LetterIsoLanguage(this.consents[0]?.language ?? "de-DE");
  }

  okClicked(): void {
    if (this.agreedControl.value) {
      this.dialogRef.close(true);
    }
  }

  onTabChanged(val: { language: string; tabIndex: number }): void {
    this.viewLanguage = ensure4LetterIsoLanguage(val.language ?? "de-DE");
    this.reRender = false;
    setTimeout(() => {
      this.lastIndex = val.tabIndex;
      this.reRender = true;
    }, 10);
  }
}
